<template>
    <div class="star-item" :class="{'disabled':data['qty']<=0}">
        <img class="img" :src="data['icon_url']"/>
        <div class="center" >
            <div class="text-ellipsis-row2">{{data['description']}}</div>
            <div class="p">
                {{data['star_unit']}}
                <img src="~@/assets/icon_gold_star.png"/>
            </div>
        </div>
        <div class="right">
            <div class="number-box" v-if="num>0">
                <img class="icon" @click="remove" src="~@/assets/remove_star.png"/>
                <div class="text">{{num}}</div>
                <img class="icon" @click="add" src="~@/assets/add_star.png"/>
            </div>
            <div v-else class="add-num">
                <img class="icon" @click="add" src="~@/assets/ic_vec_add_circle_dark.png"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['data'],
    data(){
        return {
            num:0
        }
    },
    methods:{
        remove(){
            this.num--;
        },
        add(){
            if(this.data['qty'] <=0){
                return;
            }else if(this.num+1>this.data['qty']){
                this.$msg(`最多添加${this.data['qty']}份`);
            }else{
                this.num++;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.star-item{
    display: flex;
    margin: 40px 30px;
    align-items: center;

    &.disabled{
        opacity: 0.4;
    }

    .img{
        width: 100px;
        height: 100px;
        display: block;
        margin-right: 30px;
    }

    .center{
        flex: 1;
        min-width: 0;

        .p{
            font-size: 30px;
            font-weight: bold;
            
            img{
                width: 20px;
                height: 20px;
            }
        }
    }

    .right{
        width: 160px;
        margin-left: 30px;
        text-align: right;

        .add-num{
            float: right;
            width: 50px;
            height: 50px;
            margin-right: 6px;
            border-radius: 50%;
            box-shadow: 0 6px 20px rgba(0,0,0,0.2);
            overflow: hidden;

            img{
                width: 70px;
                height: 70px;
                margin: -10px;
           
                display: block;
            }
        }
    }


    .number-box{
        display: flex;
        background: #00af66;
        align-items: center;
        padding: 6px;
        border-radius: 40px;

        .icon{
            width: 50px;
            height: 50px;
        }

        .text{
            color: #fff;
            flex: 1;
            text-align: center;
            font-size: 28px;
        }
    }
}
</style>